import SiteMenu from './connected';

export default SiteMenu;